import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {filter, map, mergeMap} from 'rxjs/internal/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private titleService: Title) {
    }

  ngOnInit() {
      this.router.events.pipe(
           filter(event => event instanceof NavigationEnd),
           map(() => this.activatedRoute),
           map(route => {
               while (route.firstChild) {
                   route = route.firstChild;
               }
               return route;
           }),
          filter(route => route.outlet === 'primary'),
          mergeMap(route => route.data)
        )
        // .subscribe((event) => this.titleService.setTitle('摩通科技 - ' + event['title']));
        .subscribe((event) => this.titleService.setTitle('物语云物联网基础平台 - ' + event['title']));
        // .subscribe((event) => this.titleService.setTitle('物联网云网关管理平台 - ' + event['title']));
  }
}
